<!--
    Program: RequestStatusView.vue
    Author: SDL
    Description:
    Created: 2020.03.20
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">Mobile SVC Request Status Detail</h2>
            <!-- breadcrumbs -->
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Engineer
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Mobile SVC
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Mobile SVC Request Status Detail
            </div>
            <!-- //breadcrumbs -->
            <!-- Role tit -->
            <div class="sub_tit">Role</div>
            <!-- //Role tit -->
            <!-- detail_Role -->
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>User Role</th>
                        <td>{{role}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="btn_wrap topLine"></div>
            <!-- //detail_Role -->
            <!-- Basic tit -->
            <div class="sub_tit mt40">Basic</div>
            <!-- //Basic tit -->
            <!-- detail_Basic -->
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Name</th>
                        <td>{{name}}</td>
                        <th>English Name</th>
                        <td>{{engName}}</td>
                    </tr>
                    <tr>
                        <th>ESN/IMEI Writing P/W</th>
                        <td colspan="3">{{esnImeiWritingPwd}}</td>
                    </tr>

                    <tr>
                        <th>Country</th>
                        <td colspan="3">{{country}}</td>
                    </tr>
                    <!--
                    <tr>
                        <th>Cell Phone Number</th>
                        <td>{{cellPhoneNo}}</td>
                        <th>Office Phone Number</th>
                        <td>{{officePhoneNo}}</td>
                    </tr>
                    <tr>
                        <th>Fax Number</th>
                        <td colspan="3">{{faxNo}}</td>
                    </tr>
                    -->
                </tbody>
            </table>
            <!-- <div class="btn_wrap topLine"></div>-->
            <!-- //detail_Basic -->
            <!-- Role tit -->
            <!-- <div class="sub_tit mt40">Additional</div>-->
            <!-- //Role tit -->
            <!-- detail_Role -->
            <!--
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Center Name</th>
                        <td>{{orgName}}</td>
                    </tr>
                    <tr>
                        <th>Center Address</th>
                        <td>
                            <label class="w220p">{{orgAddress.zipCode}}</label>
                            <label class="w100-230 ml10">
                                {{orgAddress.street}}
                                <br />
                                {{orgAddress.city}}
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <th>Contact Person</th>
                        <td>{{orgContactPerson}}</td>
                    </tr>
                </tbody>
            </table>
            -->
            <div class="btn_wrap topLine">
                <a class="btn_white" @click="onListBtnClick">List</a>
            </div>
        </div>
    </div>
</template>

<script>
import Vue  from 'vue';
import axios from 'axios';
import { SDLUtil, DateUtil } from '@/utils';

import qs from 'query-string';

export default {
    name: 'hhp-request-access-view',
    components: {},
    props: {
        seqNo: { type: String, required: true },
        onBackToList: { type: Function, required: true },
    },
    computed: {},
    data() {
        return {
            // Role Section
            role: '',

            // Basic Info Section
            name: '',
            engName: '',
            esnImeiWritingPwd: '',
            country: '',
            cellPhoneNo: '',
            officePhoneNo: '',
            faxNo: '',

            // Additional (Organization Info)
            orgName: '',
            orgAddress: {
                zipCode: '',
                city: '',
                street: '',
            },
            orgContactPerson: '',
        };
    },
    created() {
        this.init();
    },
    mounted() {},
    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            await this.fetchRequest(this.seqNo)
                .then(data => {
                    this.setData(data);
                })
                .catch(err => {
                    SDLUtil.alert({
                        title: 'Sorry!',
                        msg: err.code + ' - ' + err.message,
                        okLabel: 'Go back to List',
                        onOkEvt: () => {
                            this.onBackToList();
                        },
                    });
                });
            SDLUtil.showLoadingBar(false);
        },

        fetchRequest(seqNo) {
            const params = {
                seq_no: seqNo,
            };
            const path = '/basis/anysvcmobile/request/RequestIssueView.skp';
            return SDLUtil.getRequest(path, params)
                .then(data => {
                    if (data.row.length !== 1) {
                        return Promise.reject(
                            Object.assign(res, new Error('No data was found with the seqNo provided.')),
                        );
                    }
                    return data.row[0];
                })
                .catch(err => {
                    if (err.data.error.code === 'HHP_LOGIN_REQUIRED') {
                        // Retry
                        return this.fetchRequest(seqNo);
                    }
                    return err.data.error;
                });

            // return axios
            //     .get(`${SDLUtil.API_URL}/basis/anysvcmobile/request/RequestIssueView.skp`, { params })
            //     .then(res => {
            //         if (res.data.row.length !== 1) {
            //             return Promise.reject(
            //                 Object.assign(res, new Error('No data was found with the seqNo provided.')),
            //             );
            //         }
            //         return res.data.row[0];
            //     })
            //     .catch(err => {
            //         Vue.$log.error('RequestStatus Error', err);
            //         return err;
            //     });
        },

        setData(data) {
            // ENAME: ""
            // ZIPCODE: "111"
            // CONTACT_USER: "cs"
            // STREET: "cs"
            // EMAIL: ""
            // NAME: ""
            // FAX_NO: "1234567"
            // COUNTRY: ""
            // CITY: "cs"
            // IMEI_PASS: "****************************"
            // ROLE_CD: ""
            // CNAME: "cs"
            // USER_ROLE: ""
            // PHONE_CELL_NO: "1234567"
            // PHONE_OFFICE_NO: "1234567"

            this.role = data.USER_ROLE;
            this.name = data.NAME;
            this.engName = data.ENAME;
            this.roleCode = data.ROLE_CD;
            // if (roleCD == "A02" || roleCD == "A03") {
            //   $("#imeiPassHidden").hide();
            // }
            this.esnImeiWritingPwd = data.IMEI_PASS;
            this.country = data.COUNTRY;
            this.cellPhoneNo = data.PHONE_CELL_NO;
            this.officePhoneNo = data.PHONE_OFFICE_NO;
            this.faxNo = data.FAX_NO;
            this.orgName = '';
            (this.orgAddress = {
                zipCode: data.ZIPCODE,
                city: data.CITY,
                street: data.STREET,
            }),
                (this.orgContactPerson = data.CONTACT_USER);
        },

        onListBtnClick(event) {
            this.onBackToList();
        },
    },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/request/RequestStatusView.vue